(function () {
  // Track which script bundles have already been injected to prevent double-loading
  // when consent-ready fires more than once (e.g. user accepts after initial load).
  var injected = {};
  var ATTR = 'data-consent-gated';

  function run() {
    if (typeof window.hasConsent !== 'function') return;
    var c = window.__consentConfig || {};
    var head = document.head;
    var ok = { m: window.hasConsent('marketing'), a: window.hasConsent('analytics') };

    function runAfterLoadAndIdle(task) {
      var runTask = function () {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(function () {
            task();
          }, { timeout: 2500 });
          return;
        }
        setTimeout(task, 1200);
      };

      if (document.readyState === 'complete') {
        runTask();
        return;
      }
      window.addEventListener('load', runTask, { once: true });
    }

    function add(content, isSrc, key) {
      if (key) {
        if (injected[key]) return;
        injected[key] = true;
      }
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.setAttribute(ATTR, 'theme');
      if (isSrc) {
        script.src = content;
        script.async = true;
      } else {
        script.textContent = content;
      }
      head.appendChild(script);
    }

    try {
      if (ok.m) {
        runAfterLoadAndIdle(function () {
          if (c.klaviyoPublicKey && !injected.klaviyo) {
            injected.klaviyo = true;
            window.klaviyo = [];
            window._learnq = [];
            add('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js', true);
            add('var klaviyo=klaviyo||[];klaviyo.init({account:' + JSON.stringify(c.klaviyoPublicKey) + ',platform:"shopify"});');
            add('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(c.klaviyoPublicKey), true);
            var learnQ = ['identify', { shopify_locale: c.shopifyLocale || '' }];
            if (c.customerEmail) learnQ[1].$email = c.customerEmail;
            add('var _learnq=_learnq||[];_learnq.push(' + JSON.stringify(learnQ) + ');');
          }

          add(
            'localStorage.setItem("nb__region_code",' +
              JSON.stringify(c.countryIsoCode || '') +
              ');localStorage.setItem("nb__currency_code",' +
              JSON.stringify(c.currencyCode || '') +
              ');',
            false,
            'northbeam-locale',
          );
          add(
            '(function(){var e,n=e=e||{};n.A="identify";n.B="trackPageView";n.C="fireEmailCaptureEvent";n.D="fireCustomGoal";n.E="firePurchaseEvent";n.F="trackPageViewInitial";n.G="fireSlimPurchaseEvent";n.H="identifyCustomerId";var r="//j.northbeam.io/ota-sp/0edcf647-4226-4ffc-b7f9-7b13b698c087.js",i=function(n){for(var t=[],e=1;e<arguments.length;e++)t[e-1]=arguments[e];a.push({fnName:n,args:t})},t,a=[],o=((t={})[e.F]=function(n){i(e.F,n)},(o={_q:a})[e.A]=function(n,t){return i(e.A,n,t)},o[e.B]=function(){return i(e.B)},o[e.C]=function(n,t){return i(e.C,n,t)},o[e.D]=function(n,t){return i(e.D,n,t)},o[e.E]=function(n){return i(e.E,n)},o[e.G]=function(n){return i(e.G,n)},o[e.H]=function(n,t){return i(e.H,n,t)},Object.assign(function(n){for(var t=[],e=1;e<arguments.length;e++)t.push(arguments[e]);return i.apply(null,[n].concat(t))},o));window.Northbeam=o;(o=document.createElement("script")).async=!0;o.src=r;document.head.appendChild(o);o.trackPageViewInitial(window.location.href);})();',
            false,
            'northbeam',
          );

          if (c.enableShopmy) {
            add(
              'https://static.shopmy.us/Affiliates/sms_aff_clicktrack_VeronicaBeard_3day.js',
              true,
              'shopmy',
            );
          }

          var hightouchWriteKey = (c.hightouchWriteKey && String(c.hightouchWriteKey).trim()) || '';
          if (hightouchWriteKey && !injected.hightouch) {
            injected.hightouch = true;
            add(
              '!function(){var e=window.htevents=window.htevents||[];if(!e.initialize){if(e.invoked)window.console&&console.error&&console.error("Hightouch snippet included twice.");else{e.invoked=!0;e.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];e.factory=function(t){return function(){var n=Array.prototype.slice.call(arguments);n.unshift(t);e.push(n);return e}};for(var t=0;t<e.methods.length;t++){var n=e.methods[t];e[n]=e.factory(n)}e.load=function(t,n){var o=document.createElement("script");o.type="text/javascript";o.async=!0;o.src="https://htdata.veronicabeard.com/browser/release/v1-latest/events.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(o,r);e._loadOptions=n;e._writeKey=t};e.SNIPPET_VERSION="0.0.1";e.load(' +
                JSON.stringify(hightouchWriteKey) +
                ',{apiHost:"htdatapx.veronicabeard.com",useQueryString:false})}}}();',
            );
            if (c.analyticsJsUrl) {
              var analyticsJsScript = document.createElement('script');
              analyticsJsScript.src = c.analyticsJsUrl;
              analyticsJsScript.defer = true;
              analyticsJsScript.setAttribute(ATTR, 'theme');
              head.appendChild(analyticsJsScript);
            }
          }
        });
      }

      if (ok.a && c.heapId && !injected.heap) {
        injected.heap = true;
        runAfterLoadAndIdle(function () {
          var heapBootstrapCode = [
            '(function(){',
            'var heap=window.heap;',
            'if(heap&&typeof heap.track==="function"){',
            'if(typeof heap.push!=="function"){',
            'heap.push=function(entry){',
            'if(!Array.isArray(entry)||entry.length===0)return;',
            'var method=entry[0];',
            'var args=entry.slice(1);',
            'if(typeof heap[method]==="function"){return heap[method].apply(heap,args);}',
            '};',
            '}',
            '}else{',
            'if(!Array.isArray(heap)){heap=[];window.heap=heap;}',
            'if(typeof heap.push!=="function"){heap.push=Array.prototype.push.bind(heap);}',
            'heap.load=function(e,t){',
            'window.heap.appid=e;',
            'window.heap.config=t=t||{};',
            'var forceSSL=t.forceSSL||"https:"===document.location.protocol;',
            'var script=document.createElement("script");',
            'script.type="text/javascript";',
            'script.defer=true;',
            'script.src=(forceSSL?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";',
            'var firstScript=document.getElementsByTagName("script")[0];',
            'firstScript.parentNode.insertBefore(script,firstScript);',
            'for(var makeMethod=function(method){return function(){heap.push([method].concat(Array.prototype.slice.call(arguments,0)));};},methods=["addEventProperties","addUserProperties","clearEventProperties","identify","removeEventProperty","setEventProperties","track","unsetEventProperty"],index=0;index<methods.length;index++){heap[methods[index]]=makeMethod(methods[index]);}',
            '};',
            'heap.load(' + JSON.stringify(c.heapId) + ');',
            '}',
            '})();',
          ].join('');
          add(heapBootstrapCode);

          var heapEmail = c.customerEmail || c.checkoutEmail || '';
          var heapProps = {
            Name: c.customerName || '',
            email: heapEmail,
            CustomerID: String(c.customerId || ''),
            TotalSpent: String(c.totalSpent || ''),
          };
          add(
            '(function(){if(!window.heap)return;if(typeof heap.identify==="function"){heap.identify(' +
              JSON.stringify(heapEmail) +
              ');}if(typeof heap.addUserProperties==="function"){heap.addUserProperties(' +
              JSON.stringify(heapProps) +
              ');}})();',
          );
        });
      }
    } catch (error) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('Consent gated loader:', error);
      }
    }
  }

  // Only run once consent-ready fires (dispatched by consent-helper.js after OneTrust
  // has initialized, or after its 5s timeout if OneTrust is absent). Never run early
  // on DOMContentLoaded - OptanonActiveGroups may not be set yet, causing hasConsent
  // to incorrectly return true and load gated scripts before consent is known.
  window.addEventListener('consent-ready', run);
})();
